<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from "@/mixin/storeGenerator";

export default {
  name: "WrapperInventoryTranferBooks",
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: "inventoryTranferBooksModule"
    };
  }
};
</script>
